import {APPEAL_ENABLED, IS_LOCAL_DEV, STAGE} from "src/app/config/EnvConfig";
import {StringUtil} from "src/app/util/StringUtil";
import {Stage} from "src/app/constant/Enums";
export const EMPTY_STR = "";

export const isDev = () => {
    // use ENV config when running on non-dev env
    if (!StringUtil.isNullOrEmpty(IS_LOCAL_DEV) && IS_LOCAL_DEV.indexOf("{{") == -1) {
        return IS_LOCAL_DEV.toString().toLowerCase() === 'true';
    }
    // for local dev unit test
    return process.env.IS_DEV?.toLowerCase() === 'true'
};

/**
 * Master switch for serving local mock data instead of calling the backend.
 * Flipped to `false` now that Lighthouse APIs (GetLighthouseReview, attachments) are deployed.
 * Hard-gated off in prod via STAGE so a forgotten flip can never serve mock data to
 * production users (see AutoSDE feedback on CR-292987766).
 */
export const USE_MOCK_DATA = false;

/** True only when the mock flag is on AND we are not running against the prod stage. */
export const isMockEnabled = (): boolean => USE_MOCK_DATA && !isProdStage();

/** True when the deployed stage is prod (STAGE is template-injected per deployment). */
export const isProdStage = (): boolean => {
    if (!StringUtil.isNullOrEmpty(STAGE) && STAGE.indexOf("{{") == -1) {
        return STAGE.toLowerCase() === Stage.PROD;
    }
    // local dev / unit test: not prod
    return false;
};

/** Markets where SLP escalation is supported. Mirrors the copy in
 *  ODQAndReliabilityDecisionFooter, which is left untouched by the Lighthouse migration. */
export const SLP_SUPPORTED_COUNTRIES = new Set(["US", "CA", "UK", "GB"]);

export const isAppealEnable = () => {
    // use ENV config when running on non-dev env
    if (!StringUtil.isNullOrEmpty(APPEAL_ENABLED) && APPEAL_ENABLED.indexOf("{{") == -1) {
        return APPEAL_ENABLED.toString().toLowerCase() === 'true';
    }
    // for local dev unit test
    return process.env.APPEAL_ENABLED?.toLowerCase() === 'true'
}

/**
 * API result constants — matches the Java backend Constants.SUCCESS = "success" (lowercase).
 * The EEPL backend consistently returns lowercase for all Lighthouse activities
 * (GetLighthouseReview, SubmitDecision, attachment APIs).
 * Use these constants for mock returns and the isSuccessResult() helper for checks.
 */
export const API_RESULT_SUCCESS = 'success';
export const API_RESULT_ERROR = 'error';

/** Case-insensitive check for backend result field. Handles null/undefined safely. */
export const isSuccessResult = (result: string | undefined | null): boolean =>
    result?.toLowerCase() === API_RESULT_SUCCESS;

export const DEFAULT_PAGE_SIZE = 10;

/** Default page size for the Case Audit (Management) table. */
export const CASE_AUDIT_PAGE_SIZE = 20;

/** Maximum number of cases a Manager can select for a Bulk Action. */
export const MAX_BULK_SELECTION = 1000;
